import { useEffect, useRef, useState } from "react";
import AsyncSelect from "react-select/async";

import { getVendors } from "../../../MyApi/vendors";
import SkeletonWrapper from "../skeletonWrapper";

const EnhancedSearchVendor = ({
  setVendorId,
  value,
  setErrors,
  disabled,  
  isMulti,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const timeOutId = useRef(null);
  const [defaultVendors, setDefaultVendors] = useState([]);

  useEffect(() => {
    if (!value || !defaultVendors.length) {
      setSelectedOption(null);
      return;
    }

    setSelectedOption(value);
  }, [defaultVendors, value]);

  useEffect(() => {
    const fetchDefaultVendors = async () => {
      setLoading(true);
      try {
        const res = await getVendors("","",{is_owner: 1});
        setDefaultVendors(res?.data?.vendors || []);
      } catch (err) {
        setDefaultVendors([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDefaultVendors();
  }, []);

  const handleSearch = (selectedOptions) => {
    if (!selectedOptions) {
      setVendorId("");
      setSelectedOption(null);
      return;
    }
    setSelectedOption(selectedOptions);
    const vendorId = selectedOptions ? selectedOptions.id : "";
    const vendorName = selectedOptions ? selectedOptions.full_name : "";
     console.log('vendorId', vendorId)
     console.log('vendorName', vendorName)
    if (isMulti) {
      setVendorId(selectedOptions);
    } else {
      setVendorId(vendorId, vendorName);
    }
  };

  const enhancedSearchVendors = (value) => {
    return new Promise((resolve) => {
      if (value.length >= 5) {
        clearTimeout(timeOutId.current);
        timeOutId.current = setTimeout(async () => {
          try {
            let res = await getVendors("", 1, { search: value ,is_owner: 1});
            resolve(res.data.vendors || []);
          } catch (error) {
            resolve([]);
          }
        }, 500);
      } else {
        resolve([]);
      }
    });
  };

  return (
    <SkeletonWrapper isLoading={isLoading}>
      <AsyncSelect
        getOptionValue={(e) => e.id}
        getOptionLabel={(e) => e.full_name  }
        loadOptions={enhancedSearchVendors}
        value={selectedOption}
        onChange={handleSearch}
        defaultOptions={defaultVendors}
        placeholder="اختار المالك"
        isClearable
        isDisabled={disabled || isLoading}
        isLoading={isLoading}
        isMulti={isMulti}
      />
    </SkeletonWrapper>
  );
};

export default EnhancedSearchVendor;